import * as React from "react";
import { forwardRef } from "react";
const SvgExpandMoreIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9.414, height: 5.207, viewBox: "0 0 9.414 5.207", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "Dropdown_Arrow", "data-name": "Dropdown Arrow", d: "M136,252l4,4,4-4", transform: "translate(144.707 256.5) rotate(180)", fill: "none", stroke: "#323232", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1 }));
const ForwardRef = forwardRef(SvgExpandMoreIcon);
export { ForwardRef as ReactComponent };
